import React, { Component } from 'react';
import $ from 'jquery'
import OnlineApiService from '../../services/online-api.service';
import OnlineEncodeDecodeService from '../../services/online-encdec.service';
import { globalConstants } from '../../constants/globalConstants'
import GlobalStoreService from "../../services/global-store.service";
import PlatformType from "../../enums/PlatformType";
import GLOBAL_CONFIG from '../../config/config';
import LoginService from '../../services/handle-user-login.service';

const initialState = {
    button_text: 'REQUEST OTP',
    input_fields: {
        mobile_number:
        {
            label: 'MOBILE NUMBER',
            field_disabled: false,
            field_type: 'text', value: '', digits: 10,
            field_name: 'mobile_number',
            field_placeholder: 'Enter Your Mobile Number',
        },
        otp: {
            hidden: true,
            label: 'OTP',
            value: '',
            field_disabled: false,
            field_type: 'text',
            digits: 4,
            field_name: 'otp',
            field_placeholder: 'Enter OTP',
        }
    },
    login_stage: 'request_otp',
    button_disabled: false,
    response_msg: ''
}
class LoginWeb extends Component {



    constructor(props) {
        super(props)
        this.state = initialState

    }

    componentWillReceiveProps(newProps) {
        // console.log('login state component will receive props',newProps);
        if (newProps.resetLoginState) {
            this.setState({ ...initialState })
        }
    }

    componentDidMount() {

        document.getElementById("mobile_number")
            .addEventListener("keyup", function (event) {
                event.preventDefault();
                if (event.keyCode === 13) {
                    document.getElementById("login_button_id").click();
                }
            });
        document.getElementById("otp")
            .addEventListener("keyup", function (event) {
                event.preventDefault();
                if (event.keyCode === 13) {
                    document.getElementById("login_button_id").click();
                }
            });

    }
    onChange = (e) => {
        let input_name = e.target.name;
        let input_value = e.target.value;

        if (this.state.response_msg !== '' && this.state.login_stage !== 'verify_otp') {
            this.setState({ response_msg: '' })
        }
        if (!isNaN(input_value)) {

            this[input_name] = input_value
            let input_fields = { ...this.state.input_fields }
            input_fields[input_name].value = input_value
            if (input_fields[input_name].error_message && input_fields[input_name].error_message !== '' && input_value.length === input_fields[input_name].digits) {
                input_fields[input_name].error_message = ''
            }
            this.setState({ input_fields })
        }
        else {
            this.setState({ input_fields: this.state.input_fields })
        }
    }
    validateField = (field, value = this.state.input_fields[field.field_name].value) => {

        if (!isNaN(value)) {

            let field_valid = false

            if (!value || value.length !== field.digits) {
                field['error_message'] = `Please enter a valid ${field.label.toLowerCase()}`
                field_valid = false
            }
            else {
                field['error_message'] = ``;
                field_valid = true;
            }

            let input_fields = this.state.input_fields;
            input_fields[field.field_name] = field;

            this.setState({ input_fields: input_fields });
            return field_valid

        }
    }

    resendOtp = () => {
        if (!this.state.button_disabled) {
            OnlineApiService.generateOtp(this.requestKey).then(
                (result) => {
                    result = JSON.parse(OnlineEncodeDecodeService.decryptForOTP(result.data, result.headers["googlecookie"]));

                    if (
                        result &&
                        result.result &&
                        result.result.indexOf("SENT") !== -1
                    ) {
                        //---- success -----

                        let mobile_number = { ...this.state.input_fields.mobile_number, field_disabled: true }
                        let otp = { ...this.state.input_fields.otp, hidden: false }
                        this.setState({
                            input_fields: { ...this.state.input_fields, mobile_number, otp },
                            button_text: 'VERIFY OTP',
                            response_msg: 'Enter the OTP sent on your mobile number!',
                            login_stage: 'verify_otp'
                        })

                    } else if (
                        result &&
                        result.result &&
                        result.result === "LIMIT_REACHED_DAY"
                    ) {
                        this.setState({ button_text: 'REQUEST OTP', response_msg: globalConstants.error.limitReached })
                    } else {
                        this.setState({ button_text: 'REQUEST OTP', response_msg: globalConstants.error.otpSendError })
                    }
                },
                () => {
                    this.setState({ button_text: 'REQUEST OTP', response_msg: globalConstants.error.otpSendError })
                }
            );
        }
    }


    onSubmit = () => {

        if (this.state.login_stage === "request_otp") {

            let number_valid = this.validateField(this.state.input_fields.mobile_number)
            if (number_valid) {
                //check user api
                this.setState({ button_text: 'Sending OTP...' })
                OnlineApiService.checkUser($('#mobile_number').val()).then(
                    response => {
                        response = JSON.parse(OnlineEncodeDecodeService.decryptForOTP(response.data, response.headers["googlecookie"]));
                        this.requestKey = response.requestkey;

                        OnlineApiService.generateOtp(this.requestKey).then(
                            (result) => {
                                result = JSON.parse(OnlineEncodeDecodeService.decryptForOTP(result.data, result.headers["googlecookie"]));

                                if (
                                    result &&
                                    result.result &&
                                    result.result.indexOf("SENT") !== -1
                                ) {
                                    //---- success -----

                                    let mobile_number = { ...this.state.input_fields.mobile_number, field_disabled: true, hidden: true }
                                    let otp = { ...this.state.input_fields.otp, hidden: false }
                                    this.setState({
                                        input_fields: { ...this.state.input_fields, mobile_number, otp },
                                        button_text: 'VERIFY OTP',
                                        // response_msg: 'Enter the OTP sent on your mobile number!',
                                        response_msg: '',
                                        login_stage: 'verify_otp'
                                    })

                                } else if (
                                    result &&
                                    result.result &&
                                    result.result === "LIMIT_REACHED_DAY"
                                ) {
                                    this.setState({ button_text: 'REQUEST OTP', response_msg: globalConstants.error.limitReached })
                                } else {
                                    this.setState({ button_text: 'REQUEST OTP', response_msg: globalConstants.error.otpSendError })
                                }
                            },
                            () => {
                                this.setState({ button_text: 'REQUEST OTP', response_msg: globalConstants.error.otpSendError })
                            }
                        );
                    },
                    () => {
                        this.setState({ button_text: 'REQUEST OTP', response_msg: globalConstants.error.otpSendError })
                    }
                )
            }
        }
        else if (this.state.login_stage === "verify_otp") {

            let otp_valid = this.validateField(this.state.input_fields.otp, $('#otp').val())
            if (otp_valid) {
                this.setState({ button_text: 'Verifying OTP...', response_msg: '' })
                OnlineApiService.validateOtp(this.requestKey, this.otp).then(
                    res => {
                        res = JSON.parse(OnlineEncodeDecodeService.decryptForOTP(res.data, res.headers["googlecookie"]));

                        if (res && res.result === "SUCCESS_AIRTEL") {
                            //---- validation successfull ----

                            OnlineApiService.authLogin(this.requestKey).then(
                                response => {

                                    let mobNo = this.state.input_fields.mobile_number.value
                                    let loginType = globalConstants.TRACKING_EVENTS_CONSTANTS.loginType.OTP

                                    LoginService.loginInWeb(mobNo, loginType).then(() => {
                                        window.parent.postMessage(
                                            {
                                                message: "LOGGEDIN",
                                                value: mobNo
                                            },
                                            GLOBAL_CONFIG.parentOrigin
                                        );
                                        this.props.afterLoginAtALaterStage();
                                    }).catch((err) => {
                                        this.setState({ button_text: 'VERIFY OTP', response_msg: globalConstants.error.validateError })
                                    })
                                },
                                err => {
                                    this.setState({ button_text: 'VERIFY OTP', response_msg: globalConstants.error.validateError })
                                }
                            )
                        } else if (
                            res &&
                            res.data &&
                            res.data.result.indexOf("INCORRECT") !== -1
                        ) {
                            this.otp = "";
                            this.setState({ button_text: 'VERIFY OTP', response_msg: globalConstants.error.inCorrectOtp })
                        } else {

                            this.setState({
                                button_text: 'VERIFY OTP',
                                response_msg: globalConstants.error.validateError
                            })
                        }
                    },
                    (err) => {
                        this.setState({ button_text: 'VERIFY OTP', response_msg: globalConstants.error.validateError })
                    }
                );
            }
        }

    }
    render_fields = () => {
        let fields = this.state.input_fields;
        let fields_render = []
        for (let i in fields) {
            fields_render.push(
                <div key={i} style={{ display: (fields[i].hidden) ? 'none' : 'block' }} className="pull-left width-full">
                    <label
                        className="fs-11 color-light-grey fs-light pl-10 pt-5 pull-left border-bottom pb-5 width-full">
                        {fields[i].label}
                    </label>
                    <input maxLength={`${fields[i].digits}`} disabled={fields[i].field_disabled} id={fields[i].field_name} name={fields[i].field_name} type={fields[i].field_type} className={"fs-light pull-left " + (GlobalStoreService.get('platformType') !== PlatformType.WEB ? 'mobile-input' : 'width-full')} width="260"
                        placeholder={fields[i].field_placeholder} value={fields[i].value && fields[i].value} onChange={(e) => { this.onChange(e) }} />
                    <p className="pl-10" style={{ fontSize: '12px', color: 'red', padding: '10px' }}>{fields[i].error_message}</p>
                </div>
            )
        }
        return fields_render.map(field => field)
    }

    render() {
        return (
            <div className="login-bar-web" style={{ position: 'static' }}>
                <div className="width-full pb-20 pull-left"><p
                    className="display-inline-block fs-20 fs-regular pl-10 pt-10 color-mid-grey">Please Login</p><a
                        href="javascript:void(0)"
                        className="text-right pr-20 fs-14 color-mid-grey  display-inline-block pt-15 pb-10 pull-right fs-regular"
                        onClick={() => {
                            this.props.onSkipClick({})
                        }}
                    >Skip &rsaquo;</a>
                </div>
                <div>
                    {this.state.response_msg && this.state.response_msg !== '' && <div style={{ float: 'left', width: '100%' }}><p className="pl-10" style={{ fontSize: '12px', color: 'red', padding: '10px' }}>{this.state.response_msg}</p></div>}
                    {this.state.login_stage == 'verify_otp' &&
                        <div style={{ marginLeft: '10px', marginBottom: '10px' }}>
                            <p className='fs-13 color-dark-grey fs-regular'> We’ve sent you an OTP on</p>
                            <p className='fs-13 color-dark-grey fs-regular mt-5'>{this.state.input_fields.mobile_number.value}</p>

                            <a className="fs-12" style={{ color: '#e40000' }} href='#' onClick={() => { this.resendOtp() }}>Resend OTP</a>
                        </div>
                    }
                    <div className="pull-left" style={{ width: '50%' }}>
                        {this.render_fields.bind(this)()}
                    </div>
                    <div className="pull-right" style={{ width: '50%' }}>
                        <button id="login_button_id" style={{ outline: 'none', width: '130px' }} disabled={this.state.button_disabled}
                            className={"login-button fs-light color-white fs-13 pull-left ml-20 pl-10 pr-10 pull-right mr-20 " + (GlobalStoreService.get('platformType') !== PlatformType.WEB ? 'login-button-mobile' : '')}
                            onClick={() => { this.onSubmit() }}
                        >{this.state.button_text}</button>
                    </div>
                </div>

            </div>
        );
    }
}

export default LoginWeb;


// WEBPACK FOOTER //
// ./src/components/bottom-components/login-web.component.js